import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import CourseForm from './CourseForm';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from './store/actions';
import * as LessonActions from '../lesson/store/actions';
import * as ModuleActions from '../module/store/actions';
import * as paramActions from '../../components/paramHistory/store/actions';
import { Button, Tab, Tabs, Grid, Divider, DialogTitle, DialogContent, DialogActions, Dialog, Typography, IconButton, Icon, TextField } from '@material-ui/core';
import ModelAssetList from '../asset/ModelAssetList';
import CourseSchedule from './CourseSchedule';
import CourseLessonList from './CourseLessonList';
import * as validatorActions from '../../components/validator/store/actions';
import FourWeekBlock from './scheduleComponents/FourWeekBlock';
import CourseBuilderHeader from '../../components/CourseBuilderHeader';
import RelationUpdateTabs from '../../components/RelationUpdateTabs';
import StaticRelationList from '../../components/StaticRelationList';
import TabPanelButtons from '../../components/TabPanelButtons';
import BlankUnscheduledCourse from './builderComponents/BlankUnscheduledCourse';
import CourseDetailSchedule from './CourseDetailSchedule';
import CourseEnrollmentDescription from './CourseEnrollmentDescription';
import PageHeader from 'main/components/PageHeader';
import { getSharedTextFieldProps } from '../../components/helpers';
import _ from 'lodash';

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64,
        flex: 1
    },
    tabRoot: {
        height: 64,
        [theme.breakpoints.up('md')]: {
            minWidth: '144px'
        }
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
        minWidth: '80%',
        maxWidth: '80%'
    },
});

class Course extends Component {
    state = {
        current_tab: 0,
        company_id: 0,
        view_type: '',
        tabValue: 0,
        deleteDialogActive: false,
        lockDialogActive: false,
        unlockDialogActive: false,
        activateDialogActive: false,
        copyDialogActive: false
    }

    constructor(props) {
        super(props);

        const course_id = this.props.match.params.course_id;
        const view_type = this.props.match.params.view_type;

        if (props.paramHistory.active) {
            this.state = {
                ...this.state,
                current_tab: 3
            }
        }

        this.state = {
            ...this.state,
            course_id: course_id,
            view_type: view_type,
        }

        this.props.updateCourseLoaded(false);
        if (view_type !== 'create') {
            this.props.getAppQualificationData();
            this.props.getCourseData(course_id, this.props.auth.user.data.auth_id);
        } else {
            this.props.updateCourseLoaded(true);
            this.props.getAllModules(this.props.auth.user.data.auth_id);
            this.props.getAllLessons(this.props.auth.user.data.auth_id);
            this.props.getAllQualifications(this.props.auth.user.data.auth_id);
            this.props.getAppQualificationData();
        }

        const validationList = [
            {
                field_name: 'CourseName', functionName: ['checkRequiredFilled']
            },
            {
                field_name: 'app_role_id', functionName: ['checkFieldNotValue'], notValue: 0
            }
        ]

        this.props.startValidator(validationList)
    }

    componentDidUpdate = () => {
        const x = document.getElementsByClassName('DraftEditor-root');

        if (x.length > 0) {
            x[0].style.height = '300px';
        }

        if (!_.isEqual(parseInt(this.props.match.params.course_id), this.props.currentCourse.course_id) && this.props.repullCourse ) {
            this.setState({
                ...this.state,
                course_id: this.props.match.params.course_id,
                copyDialogActive: false
            });
            this.props.updateCourseLoaded(false);
            this.props.getCourseData(this.props.match.params.course_id, this.props.auth.user.data.auth_id);
            const validationList = [
                {
                    field_name: 'CourseName', functionName: ['checkRequiredFilled']
                },
                {
                    field_name: 'app_role_id', functionName: ['checkFieldNotValue'], notValue: 0
                }
            ]
    
            this.props.startValidator(validationList)
        }
    }

    handleChangeTab = (event, value) => {
        this.setState({
            ...this.state,
            current_tab: value
        })
    }

    handleChangeIndex = index => {
        this.setState({ value: index });
    };

    handlePrerequisiteSearchChange = (e) => {
        this.props.prerequisiteUpdateSearch(e.target.value)
    }

    handleCompanySearchChange = (e) => {
        this.props.companyUpdateSearch(e.target.value)
    }

    handleSubmit = () => {
        const auth_id = this.props.auth.user.data.auth_id;
        switch (this.state.view_type) {
            case ("create"):
                {
                    this.props.updateCourseListLoaded(false)
                    this.props.saveCourse(this.props.currentCourse, this.props.mappedLessons, this.props.currentCoursePrerequisiteList, auth_id, this.props.companies);
                    this.props.history.push('/course/list');
                    break;
                }

            case ("edit"):
                {
                    this.props.updateCourseListLoaded(false)
                    this.props.saveCourse(this.props.currentCourse, this.props.mappedLessons, this.props.currentCoursePrerequisiteList, auth_id, this.props.companies);
                    this.props.history.push('/course/list');
                    break;
                }
            case ("builder"):
                {
                    this.props.saveCourse(this.props.currentCourse, [], [], auth_id, this.props.companies);
                    this.props.history.push('/builder/course');
                    break;
                }
            default:
                {

                }
        }
    }

    handleDeleteDialogOpen = () => {
        this.setState({ deleteDialogActive: true });
    }

    handleActivateDialogOpen = () => {
        this.setState({ activateDialogActive: true });
    }

    handleLockDialogOpen = () => {
        this.setState({ lockDialogActive: true });
    }

    handleUnlockDialogOpen = () => {
        this.setState({ unlockDialogActive: true });
    }

    handleActivate = () => {
        this.props.activateCourse(this.props.currentCourse.course_id, this.props.auth.user.data.auth_id);
        this.setState({ activateDialogActive: false });
        return true
    }

    handleDelete = () => {
        switch (this.state.view_type) {
            case ("edit"):
                {
                    this.props.deleteCourse(this.props.currentCourse.course_id, this.props.auth.user.data.auth_id);
                    this.props.history.push('/course/list');
                    break;
                }

            default:
                {

                }

        }
    }

    handleBack = () => {
        this.props.clearParams();
        this.props.resetBuilder();

        if (this.props.auth.user.role === 'student') {
            return this.props.history.push('/student/courses');
        }
        return this.props.history.push('/course/list');
    }

    handleLock = () => {
        this.props.lockCourse(this.props.currentCourse.course_id, this.props.auth.user.data.auth_id);
        this.setState({ lockDialogActive: false });
        return true
    }

    handleUnlock = () => {
        this.props.unlockCourse(this.props.currentCourse.course_id);
        this.setState({ unlockDialogActive: false });
        return true
    }

    createCopy = () => {
        const { currentCourse, auth, mappedLessons, currentCoursePrerequisiteList, companies } = this.props
        return this.props.saveCourseCopy(
            {
                ...currentCourse,
                CourseName: this.props.NewCourseName,
                course_id: 0,
                CopiedFromID: this.props.currentCourse.course_id,
            },
            mappedLessons,
            currentCoursePrerequisiteList,
            auth.user.data.auth_id,
            companies
        )
    }

    getCopyDialog = (active) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ copyDialogActive: false })}
                fullWidth
                maxWidth={'md'}

            >
                <DialogTitle>Choose a new name</DialogTitle>

                <TextField
                    required
                    id="NewCourseName"
                    label="New Course Name"
                    value={this.props.NewCourseName}
                    onChange={(e) => this.props.updateNewCourseName(e.target.value)}
                    {...getSharedTextFieldProps(this.state.view_type, this.props.classes)}
                />

                <DialogActions>
                    <Button onClick={() => this.createCopy(true)} color="primary">
                        Create Copy
                    </Button>

                    <Button onClick={() => this.setState({ copyDialogActive: false })} color="primary" autoFocus>
                        Back
                    </Button>
                </DialogActions>

            </Dialog>
        )
    }

    handleCopyClick = () => {
        this.setState({ copyDialogActive: true })
    }

    getPageContent = (current_tab, view_type) => {
        const { theme, classes, currentCourse, potentialCoursePrerequisites, currentCoursePrerequisiteList,
            allModules, currentCourseModuleList, mappedLessons, duplicateLessons,
            confirmDragDialog, confirmDragDialogID, overwrittenLessons, allLessons, modulePreviewData } = this.props;

        const mappedPrerequisites = currentCoursePrerequisiteList.map(P => { return { label: P.CourseName, id: P.course_id } });
        const mappedPotentialPrerequisites = potentialCoursePrerequisites.map(P => { return { label: P.CourseName, id: P.course_id } });

        let activeModuleIDs = mappedLessons.map(lesson => {
            return lesson.module_id
        });

        let orderedModules = allModules.filter(module => activeModuleIDs.indexOf(module.module_id) !== -1)
        switch (current_tab) {
            case (0): // Detail
                {
                    return (
                        <CourseForm
                            view_type={view_type}
                        />
                    )
                }
            case (1): // Assets
                {
                    return (
                        <ModelAssetList
                            view_type={view_type}
                            model_type='course'
                            model_id={this.props.currentCourse.course_id}
                            file_type="Course File"
                            assetList={this.props.currentCourse.assetList}
                            getAssetList={this.props.getCourseAssetList}
                            updateAssetNameFunc={this.props.updateAssetName}
                        />
                    )
                }
            case (2): // Schedule
                {
                    if (view_type === 'detail') {
                        return (
                            <CourseDetailSchedule
                                Unscheduled={currentCourse.Unscheduled === 1 ? true : false}
                                mappedLessons={mappedLessons}
                                month={this.props.month}
                                toggleMonth={this.props.toggleMonth}
                            />
                        )

                    }
                    else {
                        if (currentCourse.Unscheduled === 0) {
                            return (
                                <CourseSchedule
                                    course_id={currentCourse.course_id}
                                    course={this.props.currentCourse}
                                    allModules={allModules}
                                    allLessons={allLessons}
                                    alreadySelectedModules={orderedModules}
                                    currentCourseModuleList={currentCourseModuleList}
                                    mappedLessons={mappedLessons}
                                    month={this.props.month}
                                    duplicateLessons={duplicateLessons}
                                    overwrittenLessons={overwrittenLessons}
                                    confirmDragDialog={confirmDragDialog}
                                    confirmDragDialogID={confirmDragDialogID}
                                    modulePreviewData={modulePreviewData}
                                    view_type={view_type}
                                />
                            )
                        }
                        else {
                            return (
                                <BlankUnscheduledCourse
                                    key={1}
                                    mappedLessons={mappedLessons}
                                    courseBuilder={false}
                                    pushUnscheduledLesson={this.props.pushUnscheduledLessonOutsideBuilder}
                                    moveUnscheduledLesson={this.props.moveUnscheduledLessonOutsideBuilder}
                                    handleUnscheduledLessonDelete={this.props.deleteUnscheduledLessonOutsideBuilder}
                                />
                            )
                        }
                    }
                }
            case (3): // Lessons
                {
                    return (
                        <CourseLessonList lessonList={this.props.mappedLessons} currentCourse={currentCourse} prereqs={currentCoursePrerequisiteList} companies={this.props.companies} auth_id={this.props.auth.user.data.auth_id}/>
                    )
                }
            case (4): // Prerequisites
                {
                    return (
                        view_type === 'detail' ?
                            <Grid container spacing={24}>
                                <Grid item xs={6}>
                                    <StaticRelationList
                                        rootClass={classes.root}
                                        items={mappedPrerequisites}
                                        header='Course Prerequisites'
                                    />
                                </Grid>
                            </Grid>
                            :
                            <RelationUpdateTabs
                                currentRelationsTabData={mappedPrerequisites}
                                handleDelete={this.props.togglePrerequisiteCourse}
                                availableObjectList={mappedPotentialPrerequisites}
                                handleAdd={this.props.togglePrerequisiteCourse}
                                handleSearchChange={this.handlePrerequisiteSearchChange}
                                search={this.props.prerequisiteSearch}
                                leftHeader="Current Prerequisites"
                                rightHeader="All Courses"
                                view_type={view_type}
                                rootClass={classes.root}
                                dir={theme.direction}
                            />
                    );
                }
            case (5): // Enrollment Description
                {
                    return (
                        <CourseEnrollmentDescription
                            view_type={this.props.view_type}
                        />
                    )
                }
            case (6): // Prerequisites
                {
                    return (
                        view_type === 'detail' ?
                            <Grid container spacing={24}>
                                <Grid item xs={6}>
                                    <StaticRelationList
                                        rootClass={classes.root}
                                        items={this.props.companies}
                                        header='Companies'
                                    />
                                </Grid>
                            </Grid>
                            :
                            <RelationUpdateTabs
                                currentRelationsTabData={this.props.companies}
                                handleDelete={this.props.toggleCompany}
                                availableObjectList={this.props.allCompanies}
                                handleAdd={this.props.toggleCompany}
                                handleSearchChange={this.handleCompanySearchChange}
                                search={this.props.companySearch}
                                leftHeader="Current Companies"
                                rightHeader="All Companies"
                                view_type={view_type}
                                rootClass={classes.root}
                                dir={theme.direction}
                            />
                    );
                }
            default:
                {
                    return <React.Fragment>Error: No tab found.</React.Fragment>
                }
        }

    }

    getActivateDialog = (active, course) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ activateDialogActive: false })}
            >
                <DialogTitle>Confirm Activate {course.CourseName}?</DialogTitle>
                <DialogContent>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleActivate()} color="primary">
                        Activate
                        </Button>
                    <Button onClick={() => this.setState({ activateDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }

    getDeleteDialog = (active, course) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ deleteDialogActive: false })}
            >
                <DialogTitle>Confirm Deactivate {course.CourseName}?</DialogTitle>
                <DialogContent>
                    {this.props.deleteAllowed ? null :
                        <React.Fragment>
                            <Typography variant="h6">The following relationships will be deactivated:</Typography>
                            {this.props.mappedLessons.length > 0 ?
                                <React.Fragment>
                                    <Typography variant="h6">Lessons</Typography>
                                    {this.props.mappedLessons.map(l => {
                                        return (
                                            <Typography variant="body1" key={l.lesson_id}>{l.LessonName}</Typography>
                                        )
                                    })}
                                </React.Fragment>
                                : null
                            }
                            {this.props.courses_on_schedule.length > 0 ?
                                <React.Fragment>
                                    <Typography variant="h6">Calendars</Typography>
                                    {this.props.courses_on_schedule.map(c => {
                                        return (
                                            <Typography variant="body1" key={c.company_calendar_course_id}>{c.CompanyName}</Typography>
                                        )
                                    })}
                                </React.Fragment>
                                : null
                            }
                        </React.Fragment>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleDelete()} color="primary">
                        Deactivate
                        </Button>
                    <Button onClick={() => this.setState({ deleteDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }

    getLockDialog = (active) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ lockDialogActive: false })}
            >
                <DialogTitle>Lock Course?</DialogTitle>
                <DialogContent>
                    Only you and Company Admin level users will be able to edit the course.
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleLock()} color="primary">
                        Lock
                        </Button>
                    <Button onClick={() => this.setState({ lockDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }

    getUnlockDialog = (active) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ unlockDialogActive: false })}
            >
                <DialogTitle>Unlock Course?</DialogTitle>
                <DialogContent>
                    All company instructors will be able to edit this course.
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleUnlock()} color="primary">
                        Unlock
                        </Button>
                    <Button onClick={() => this.setState({ unlockDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }


    disableSave = () => {
        const { validator } = this.props;
        const { view_type } = this.state

        switch (view_type) {
            case ("edit"): {
                return (
                    validator.map(v => v.error)
                        .includes(true)
                )
            }
            case ('create'): {
                return !(
                    validator.every(v => v.error === false)
                )
            }
        }
    };

    getLockButtonDisplay = () => {
        const role = this.props.auth.user.role;
        const auth_id = this.props.auth.user.data.auth_id;
        // early return if its already locked
        if (this.props.currentCourse.IsLocked === 1) {
            return false;
        }

        if (role === 'dev' || role === 'admin' || role === 'company') {
            return true;
        }
        else if (role === 'instructor' && auth_id === this.props.currentCourse.CreateAuthID) {
            return true;
        }
        return false;
    }

    getUnlockButtonDisplay = () => {
        const role = this.props.auth.user.role;
        const auth_id = this.props.auth.user.data.auth_id;
        // early return if its not locked
        if (this.props.currentCourse.IsLocked === 0) {
            return false;
        }

        if (role === 'dev' || role === 'admin' || role === 'company') {
            return true;
        }
        else if (role === 'instructor' && auth_id === this.props.currentCourse.CreateAuthID) {
            return true;
        }
        return false;
    }

    hideLockedCourseActions = () => {
        const role = this.props.auth.user.role;
        const auth_id = this.props.auth.user.data.auth_id;

        if (this.props.currentCourse.IsLocked === 0) {
            return false;
        }

        if (role === 'dev' || role === 'admin' || role === 'company') {
            return false;
        }
        else if (role === 'instructor' && auth_id === this.props.currentCourse.LockedByAuthID) {
            return false;
        }
        return true;
    }

    render() {
        const { classes, currentCourse, isCourseLoaded, mappedLessons } = this.props;
        const { current_tab, view_type } = this.state;
        const delete_dialog = this.getDeleteDialog(this.state.deleteDialogActive, this.props.currentCourse);
        const activate_dialog = this.getActivateDialog(this.state.activateDialogActive, this.props.currentCourse)
        const lock_dialog = this.getLockDialog(this.state.lockDialogActive);
        const unlock_dialog = this.getUnlockDialog(this.state.unlockDialogActive);
        const authRole = this.props.auth.user.data.role_info.role_id;
        const copy_dialog = this.getCopyDialog(this.state.copyDialogActive);

        const deleteToolbarContent =
            <React.Fragment>
                <h5>This Course is being used on the following calendars:</h5>
                {this.props.courses_on_schedule.map(c => {
                    return (
                        <div key={c.company_calendar_course_id}>{c.CompanyName}: {c.StartDate} - {c.EndDate}</div>
                    )
                })}
            </React.Fragment>

        if (!isCourseLoaded) {
            return <div>loading</div>
        }

        let page_content = <React.Fragment>Loading...</React.Fragment>;
        if (isCourseLoaded) {
            page_content = this.getPageContent(current_tab, view_type);
        }

        let header_content = (
            <PageHeader
                component_name={currentCourse.CourseName}
                component_type={"course"}
                view_type={view_type}
            />
        )
        if (this.props.paramHistory.active) {
            header_content = <CourseBuilderHeader activeStep={0} baseComponent={'course'} />
        }
        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot,
                    toolbar: classes.layoutToolbar
                }}
                header={
                    header_content
                }
                contentToolbar={
                    <div style={{ width: '100%', height: '100%' }}>
                        <Grid container>
                            <Tabs
                                value={current_tab}
                                onChange={this.handleChangeTab}
                                indicatorColor="primary"
                                textColor="primary"
                                classes={{
                                    root: classes.tabsRoot
                                }}
                                scrollable={true}
                            >
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Detail"
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Assets"
                                    disabled={view_type === 'create' || view_type === 'builder'}
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Schedule"
                                    disabled={view_type === 'builder' || view_type === 'create'}
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Lesson List"
                                    disabled={view_type === 'create'}
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Prerequisites"
                                    disabled={view_type === 'create'}
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Enrollment Details"
                                    disabled={view_type === 'create'}
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Company"
                                    disabled={view_type === 'create'}
                                    hidden={authRole > 2}
                                />
                            </Tabs>
                            <TabPanelButtons
                                component_name={"course"}
                                view_type={view_type}
                                button_list={[
                                    {
                                        display: "unlock",
                                        type: "lock",
                                        onClick: this.handleUnlockDialogOpen,
                                        hidden: !this.getUnlockButtonDisplay() || view_type != 'edit'
                                    },
                                    {
                                        display: "lock",
                                        type: "lock",
                                        onClick: this.handleLockDialogOpen,
                                        hidden: !this.getLockButtonDisplay() || view_type != 'edit'
                                    },
                                    {
                                        display: "Save",
                                        type: view_type === 'create' ? 'create' : 'update',
                                        onClick: this.handleSubmit,
                                        disabled: this.disableSave(),
                                        hidden: this.hideLockedCourseActions()
                                    },
                                    {
                                        display: "Copy",
                                        type: "update",
                                        onClick: this.handleCopyClick,
                                        disabled: view_type != 'edit',
                                        hidden: view_type === 'create' || this.props.paramHistory.active
                                    },
                                    {
                                        type: "delete",
                                        display: 'Deactivate',
                                        largeLabel: true,
                                        onClick: this.handleDeleteDialogOpen,
                                        // disabled: !this.props.deleteAllowed,
                                        // tooltip: { active: !this.props.deleteAllowed, content: deleteToolbarContent },
                                        hidden: this.hideLockedCourseActions() || this.props.currentCourse.Active === 0

                                    },
                                    {
                                        type: "activate",
                                        largeLabel: true,
                                        onClick: this.handleActivateDialogOpen,
                                        // disabled: !this.props.deleteAllowed,
                                        // tooltip: { active: !this.props.deleteAllowed, content: deleteToolbarContent },
                                        hidden: this.hideLockedCourseActions() || this.props.currentCourse.Active === 1

                                    },
                                    {
                                        type: "back",
                                        onClick: this.handleBack,
                                    },
                                ]}
                            />
                        </Grid>
                    </div>
                }
                content={
                    <React.Fragment>
                        <div className="p-24">
                            {unlock_dialog}
                            {lock_dialog}
                            {delete_dialog}
                            {copy_dialog}
                            {page_content}
                            {activate_dialog}
                        </div>
                    </React.Fragment>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        toggleMonth: Actions.toggleMonth,
        getCourse: Actions.getCourse,
        updateCourseLoaded: Actions.updateCourseLoaded,
        getCourseData: Actions.getCourseData,
        deleteCourse: Actions.deleteCourse,
        saveCourse: Actions.saveCourse,
        updateCourseForm: Actions.updateCourseForm,
        getCourseAssetList: Actions.getCourseAssetList,
        getAllModules: Actions.getAllModules,
        getAllLessons: Actions.getAllLessons,
        startValidator: validatorActions.startValidator,
        clearParams: paramActions.clearParams,
        resetBuilder: Actions.resetBuilder,
        prerequisiteUpdateSearch: Actions.prerequisiteUpdateSearch,
        companyUpdateSearch: Actions.companyUpdateSearch,
        togglePrerequisiteCourse: Actions.togglePrerequisiteCourse,
        toggleCompany: Actions.toggleCompany,
        pushUnscheduledLessonOutsideBuilder: Actions.pushUnscheduledLessonOutsideBuilder,
        moveUnscheduledLessonOutsideBuilder: Actions.moveUnscheduledLessonOutsideBuilder,
        deleteUnscheduledLessonOutsideBuilder: Actions.deleteUnscheduledLessonOutsideBuilder,
        getAllQualifications: Actions.getAllQualifications,
        getAppQualificationData: Actions.getAppQualificationData,
        lockCourse: Actions.lockCourse,
        unlockCourse: Actions.unlockCourse,
        updateCourseListLoaded: Actions.updateCourseListLoaded,
        activateCourse: Actions.activateCourse,
        updateAssetName: Actions.updateAssetName,
        saveCourseCopy: Actions.saveCourseCopy,
        toggleCourseRepull: Actions.toggleCourseRepull,
        updateNewCourseName: Actions.updateNewCourseName
    }, dispatch);
}

function mapStateToProps({ courseApp, auth, lessonApp, validator, paramHistory, contentLabelReducer }) {
    return {
        currentCourse: courseApp.courses.currentCourse,
        currentCourseMajorList: courseApp.courses.currentCourseMajorList,
        currentCourseInstructorList: courseApp.courses.currentCourseInstructorList,
        currentCourseModuleList: courseApp.courses.currentCourseModuleList,
        isCourseLoaded: courseApp.courses.isCourseLoaded,
        allMajors: courseApp.courses.allMajors,
        allInstructors: courseApp.courses.allInstructors,
        allModules: courseApp.courses.allModules,
        allLessons: courseApp.courses.allLessons,
        allAssignments: lessonApp.lessons.allAssignments,
        companies: courseApp.courses.companies,
        allCompanies: courseApp.courses.allCompanies,
        month: courseApp.courses.month,
        mappedLessons: courseApp.courses.mappedLessons,
        duplicateLessons: courseApp.courses.duplicateLessons,
        overwrittenLessons: courseApp.courses.overwrittenLessons,
        confirmDragDialog: courseApp.courses.confirmDragDialog,
        confirmDragDialogID: courseApp.courses.confirmDragDialogID,
        modulePreviewData: courseApp.courses.modulePreviewData,
        validator: validator.list,
        paramHistory: paramHistory.courseBuilder,
        currentCoursePrerequisiteList: courseApp.courses.currentCoursePrerequisiteList,
        potentialCoursePrerequisites: courseApp.courses.potentialCoursePrerequisites,
        prerequisiteSearch: courseApp.courses.prerequisiteSearch,
        deleteAllowed: courseApp.courses.deleteAllowed,
        courses_on_schedule: courseApp.courses.courses_on_schedule,
        allQualifications: courseApp.courses.allQualifications,
        companySearch: courseApp.courses.companySearch,
        NewCourseName: courseApp.courses.NewCourseName,
        repullCourse: courseApp.courses.repullCourse,
        auth,
    }

}


export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Course)));



// WEBPACK FOOTER //
// src/main/content/course/Course.js